export const rejectPayloadAdapter = (trxId, codeInternal, rejectReason, observations, email) => {
	return {
		trx_id: trxId,
		code_internal: codeInternal,
		status: 'RI',
		signature: email,
		name: rejectReason,
		description: observations || '-',
		subject: rejectReason,
		message: observations,
	};
};
